import { Link } from 'react-router-dom';
import { categoryColorMap } from '@/mocks/categories';

interface CategoryCardProps {
  slug: string;
  name: string;
  icon: string;
  description: string;
  color: string;
  siteCount: number;
}

export default function CategoryCard({ slug, name, icon, description, color, siteCount }: CategoryCardProps) {
  const colors = categoryColorMap[color] || categoryColorMap.primary;

  return (
    <Link
      to={`/category/${slug}`}
      className={`group block p-5 rounded-2xl ${colors.bg} border ${colors.border} ${colors.hover} transition-all duration-300 cursor-pointer`}
    >
      <div className="flex items-start gap-4">
        <div className={`w-12 h-12 rounded-xl ${colors.bg} border ${colors.border} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
          <i className={`${icon} text-xl ${colors.text}`}></i>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className={`font-semibold text-sm mb-1 ${colors.text}`}>{name}</h3>
          <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{description}</p>
          <div className="mt-3 flex items-center gap-2">
            <span className={`text-xs px-2 py-0.5 rounded-full ${colors.bg} ${colors.text} font-medium`}>
              {siteCount}个网站
            </span>
            <span className={`text-xs ${colors.text} opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center gap-0.5`}>
              查看全部 <i className="ri-arrow-right-line text-[10px]"></i>
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}